<template>
    <div v-if="mounted"
         class="additional-course-contents"
         :class="{'additional-course-contents--loading': loading}"
    >

        <ExtendableCardList
            v-if="mounted"
            v-model="additionalCourseContents"
            v-slot="slot"
            :errors="{}"
            :data-can-be-added="!additionalCourseContents.find(acc => !acc.id)"
            confirm-delete
            data-can-be-deleted
            data-can-be-edited
            send-remove-event
            @remove="(acc) => remove(acc)"
        >

            <additional-course-content
                :key="additionalCourseContents[slot.index].id"
                :course="course"
                v-model="additionalCourseContents[slot.index]"
                :errors="errors"
                :number-of-siblings="additionalCourseContents.filter(e => e.id).length"
                @sort="(toPosition) => sort(additionalCourseContents[slot.index], toPosition)"
                @submit="(acc) => submit(acc)"
            ></additional-course-content>

        </ExtendableCardList>
    </div>
</template>
<script>

import ExtendableCardList from "../global/ExtendableCardList.vue";
import AdditionalCourseContent from "./AdditionalCourseContent.vue";

export default {
    components: {AdditionalCourseContent, ExtendableCardList},
    props: {
        course: {
            type: Object,
            required: true,
        },
        client: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            additionalCourseContents: [],
            errors: [],
            mounted: false,
            loading: true,
        }
    },
    mounted() {
        this.fetch();
        this.mounted = true;
    },
    methods: {
        sort(additionalCourseContent, toPosition) {

            this.loading = true;

            axios.post(this.route('tenantapi.additional-course-content.reorder', additionalCourseContent.id), {
                toPosition
            }).then(response => {
                this.additionalCourseContents = response.data;
                this.flash({message: this.trans('global.changed_order_successfully'), type: 'success'});
            })
            .finally(() => {
                this.loading = false;
                this.errors = [];
            })

        },
        remove(additionalCourseContent) {
            this.loading = true;

            axios.delete(this.deleteRoute(additionalCourseContent))
                .then(response => {
                    this.additionalCourseContents = response.data;
                    this.flash({message: this.trans('global.deleted_successfully'), type: 'success'});
                })
                .finally(() => {
                    this.loading = false;
                    this.errors = [];
                })

        },
        submit(additionalCourseContent) {
            this.loading = true;
            const exists = !!additionalCourseContent.id;
            const route = exists
                ? this.updateRoute(additionalCourseContent)
                : this.storeRoute()
            const method = exists ? 'put' : 'post';

            const formData = new FormData();
            formData.append('title', additionalCourseContent.title || '');
            formData.append('description', additionalCourseContent.description || '');
            formData.append('file', additionalCourseContent.file || '');
            formData.append('terms_accepted_at', additionalCourseContent['terms_accepted_at'] ? "on" : "");
            formData.append("_method", method); // we need to spoof the method, https://stackoverflow.com/questions/54686218/laravel-vuejs-axios-put-request-formdata-is-empty

            axios.post(route, formData)
                .then(response => {
                    this.additionalCourseContents = response.data;
                    this.flash({message: this.trans('global.saved_successfully'), type: 'success'});
                    this.errors = [];
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = [{
                            id: additionalCourseContent.id || null,
                            errors: error.response.data.errors
                        }];
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetch() {
            axios.get(this.indexRoute())
                .then(response => {
                    this.additionalCourseContents = response.data;
                    this.errors = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        indexRoute() {
            return this.route('tenantapi.additional-course-content.index', {
                course: this.course.id,
                client: this.client.id
            });
        },
        updateRoute(additionalCourseContent) {
            return this.route('tenantapi.additional-course-content.update', {
                'additionalCourseContent': additionalCourseContent.id
            })
        },
        storeRoute() {
            return this.route('tenantapi.additional-course-content.store', {
                'course': this.course.id,
                client: this.client.id
            });
        },
        deleteRoute(additionalCourseContent) {
            return this.route('tenantapi.additional-course-content.destroy', {
                'additionalCourseContent': additionalCourseContent.id
            })
        },

    },
}
</script>
